"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoMeasureInputEvents = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const code_enum_1 = require("../../services/input/code.enum");
const page_state_1 = require("../../state/page.state");
class PhotoMeasureInputEvents {
    constructor(page, draw) {
        this.eventCount = {};
        this.renderOptions = null;
        this.page = page;
        this.draw = draw;
        this.eventContext = services_1.Services.Input.getContext();
    }
    incrementCount(title) {
        this.eventCount[title] = (this.eventCount[title] || 0) + 1;
    }
    init() {
        this.eventContext = services_1.Services.Input.getContext();
        this.eventContext.on(code_enum_1.Code.KeyS, this.saveCollection, { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowUp, this.moveSelectedX.bind(this, -1));
        this.eventContext.on(code_enum_1.Code.ArrowUp, this.moveSelectedX.bind(this, -25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowUp, this.moveSelectedX.bind(this, -0.25), { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowDown, this.moveSelectedX.bind(this, 1));
        this.eventContext.on(code_enum_1.Code.ArrowDown, this.moveSelectedX.bind(this, 25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowDown, this.moveSelectedX.bind(this, 0.25), { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowLeft, this.moveSelectedY.bind(this, -1));
        this.eventContext.on(code_enum_1.Code.ArrowLeft, this.moveSelectedY.bind(this, -25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowLeft, this.moveSelectedY.bind(this, -0.25), { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowRight, this.moveSelectedY.bind(this, 1));
        this.eventContext.on(code_enum_1.Code.ArrowRight, this.moveSelectedY.bind(this, 25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowRight, this.moveSelectedY.bind(this, 0.25), { modifiers: { ctrl: true } });
        const isIkeAnalyst = services_1.Services.User.current && services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst) {
            this.eventContext.on(code_enum_1.Code.KeyI, () => this.draw.state.setInsightMarkersVisible(!this.draw.state.visibleInsightMarkers), { modifiers: { ctrl: true } });
            this.eventContext.on(code_enum_1.Code.KeyM, () => this.draw.state.setInsightMasksVisible(!this.draw.state.visibleInsightMasks), { modifiers: { ctrl: true } });
        }
        this.eventContext.on(code_enum_1.Code.Escape, this.clearSelected);
        // Arrange Annotations
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_ANNOTATIONS_ARRANGE) ||
            (isIkeAnalyst)) {
            this.eventContext.on(code_enum_1.Code.KeyA, e => {
                if (!this.renderOptions || !this.draw) {
                    return;
                }
                e.event.preventDefault();
                this.draw.state.setAutoArrangeAnnotations(!this.draw.state.autoArrangeAnnotations, this.renderOptions);
            }, { modifiers: { ctrl: true, shift: true } });
        }
    }
    getSelectedObject() {
        if (this.draw == null) {
            return null;
        }
        return this.draw.selected;
    }
    trackEvents() {
        var _a;
        for (const eventLabel of Object.keys(this.eventCount)) {
            const value = this.eventCount[eventLabel];
            if (value == null || value === 0) {
                continue;
            }
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, eventLabel, (_a = page_state_1.CurrentState.inspectedCaptureId) !== null && _a !== void 0 ? _a : undefined, value);
        }
    }
    clearSelected(evt) {
        page_state_1.CurrentState.cancelInteractions();
        this.incrementCount('keyboard:clear');
        const selected = this.getSelectedObject();
        if (selected == null) {
            return;
        }
        this.draw.state.setSelected(null, null);
    }
    saveCollection(evt) {
        if (this.draw == null) {
            return;
        }
        evt.event.preventDefault();
        this.incrementCount('keyboard:save');
        this.page.editControl.saveChanges(evt.event);
    }
    deleteSelected(evt) {
        const selected = this.getSelectedObject();
        if (selected == null || !this.draw.state.selectedId) {
            return;
        }
        this.incrementCount('keyboard:delete');
        core_shared_1.IkeDrawBindings.Measurement.delete(this.draw, { drawableId: this.draw.state.selectedId, $event: evt.event });
    }
    moveSelectedX(dy, evt) {
        const selected = this.getSelectedObject();
        if (selected == null) {
            return;
        }
        if (!this.renderOptions || !this.draw) {
            return;
        }
        const isUp = dy < 0;
        this.incrementCount(`keyboard:move:${isUp ? 'up' : 'down'}:${Math.abs(dy)}`);
        core_shared_1.IkeDrawBindings.Selection.move(this.draw, { delta: { x: 0, y: dy }, $event: evt.event });
        if (this.draw.state.autoArrangeAnnotations) {
            this.draw.state.arrangeAnnotations(this.renderOptions);
        }
    }
    moveSelectedY(dx, evt) {
        const selected = this.getSelectedObject();
        if (selected == null) {
            return;
        }
        const isLeft = dx < 0;
        this.incrementCount(`keyboard:move:${isLeft ? 'left' : 'right'}:${Math.abs(dx)}`);
        // Don't allow keyboard events to move labels
        const selectedRegion = this.draw.state.selectedRegion;
        const label = selectedRegion === 'label' ? null : selectedRegion;
        core_shared_1.IkeDrawBindings.Selection.move(this.draw, { delta: { x: dx, y: 0 }, $event: evt.event, label: label !== null && label !== void 0 ? label : undefined });
    }
    destroy() {
        if (this.eventContext != null) {
            this.eventContext.destroy();
        }
    }
}
exports.PhotoMeasureInputEvents = PhotoMeasureInputEvents;
tslib_1.__decorate([
    mobx_1.action.bound
], PhotoMeasureInputEvents.prototype, "clearSelected", null);
tslib_1.__decorate([
    mobx_1.action.bound
], PhotoMeasureInputEvents.prototype, "saveCollection", null);
tslib_1.__decorate([
    mobx_1.action.bound
], PhotoMeasureInputEvents.prototype, "deleteSelected", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasureInputEvents.prototype, "moveSelectedX", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasureInputEvents.prototype, "moveSelectedY", null);
//# sourceMappingURL=pm.events.js.map